/**
 * Renders the page hero with title, lead, and metadata badges.
 */
export function renderHero(): string {
  const reviewed = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  return `<header class="hero">
    <p class="hero__eyebrow">Worldwide Golf · Architecture Guide</p>
    <h1 class="hero__title">Unbxd × FastStore Integration</h1>
    <p class="hero__lead">
      How product search and listing pages are powered by Unbxd Search on top of
      VTEX FastStore — explained for leaders and technical stakeholders.
    </p>
    <div class="hero__meta">
      <span class="hero__badge">Last reviewed: ${reviewed}</span>
    </div>
  </header>`
}
